import { CheckboxSkeleton, Container, Space } from '@ag1/ui';
import SubscriptionMainCardSkeleton from '../../../shared/components/SubscriptionMainCardV2/SubscriptionMainCardSkeleton/SubscriptionMainCardSkeleton';
import Layout from '../../../shared/layouts/BaseLayout';
import SliderProduct from '../../../shared/ui/SliderProduct/SliderProduct';
import SubscriptionCardSkeleton from '../../../shared/ui/SubscriptionCardV2/SubscriptionCardSkeleton';
import styles from './styles.module.scss';

const HomeViewSkeleton = () => (
  <Layout>
    <Space top={{ xxs: 20, s: 40 }}>
      <Container>
        <div className={styles.filter}>
          <CheckboxSkeleton withLabel labelWidth={218} />
        </div>
        <div className={styles.card}>
          <SubscriptionMainCardSkeleton />
        </div>
      </Container>
    </Space>
    <Space top={{ m: 32, xxs: 16 }} bottom={{ m: 120, xxs: 80 }} className={styles.slider}>
      <SliderProduct
        title=""
        placeholder={<SubscriptionCardSkeleton />}
        controls={false}
        placeholdersCount={4}
        isLoading
        renderSlide={() => null}
        slides={[]}
      />
    </Space>
  </Layout>
);

export default HomeViewSkeleton;
